import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { ClipboardServiceInterface } from '../../../../services/clipboard/clipboard-service.interface';

@Component({
  selector: 'gtd-link-with-copy',
  templateUrl: './link-with-copy.component.html',
  styleUrls: ['./link-with-copy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkWithCopyComponent {
  @Input() link: string[];
  @Input() displayData: string;
  @Input() rbacProperty: string;
  @Input() customClass = 'c-link c-link--primary -blue';

  public showCopiedMessage = false;

  constructor(@Inject('ClipboardServiceInterface') private clipboardService: ClipboardServiceInterface) {}

  public copy($event: Event): void {
    $event.stopPropagation();
    this.clipboardService.copyFromContent(this.displayData);
    this.showCopiedMessage = true;
    setTimeout(() => {
      this.showCopiedMessage = false;
    }, 1000);
  }
}
